import { Text, Stack, Icon } from '@backyard-ui/core';

import { PhoneIcon } from './PhoneIcon';
import { WhatsAppIcon } from './WhatsAppIcon';

interface ItemProps {
  name: string;
  link: string;
  phoneNumber: string;
  locale: string;
  phoneType: 'phone' | 'whatsapp';
}

export default function Item(props: Readonly<ItemProps>) {
  const { name, link, phoneNumber, locale, phoneType } = props;

  const iconComponents = {
    whatsapp: WhatsAppIcon,
    phone: PhoneIcon,
  };

  const ItemIcon = iconComponents[phoneType];

  return (
    <a
      href={link}
      rel="noopener noreferrer"
      target="_blank"
      aria-label={`Compre pelo ${
        phoneType === 'whatsapp' ? 'WhatsApp' : 'Telefone'
      }`}
    >
      <Stack align="center" spacing="2" isWrap>
        <Icon size="xs">
          <ItemIcon />
        </Icon>

        <Text asChild>
          <span>{name}:</span>
        </Text>

        <Text color="green-600" weight="bold" asChild>
          <span>{phoneNumber}</span>
        </Text>

        <Text size="sm" color="gray-600" asChild>
          <span>{locale}</span>
        </Text>
      </Stack>
    </a>
  );
}
